import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import './nuevoStroLight.css';
import { useCookies } from 'react-cookie';
export default function SlideEstadosReclamoLight({ reclamo }) {
  const [cookies] = useCookies(['user']);
  const [estados, setEstados] = useState([]);
  const [camposEstado, setCamposEstado] = useState([]);
  const [valores, setValores] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [codigos, setCodigos] = useState([]);
  const [valoresAct, setValoresAct] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        const resCodigos = await axios.get(`https://back.agsseguros.online/api/estados/codigoAll`);
        setCodigos(
          resCodigos.data.filter(c => {
            const catStr = reclamo?.catStro?.toString();
            if (catStr && catStr.length === 3) {
              return c.codigo === Number(catStr);
            }
            return false;
          })
        );
        const resEstado = await axios.get(`https://back.agsseguros.online/api/estados/todosLosEstados`);
        setEstados(resEstado.data);
        const resCampos = await axios.get(`https://back.agsseguros.online/api/estados/todosLosCampos`);
        setCamposEstado(resCampos.data);
        const resValores = await axios.get(`https://back.agsseguros.online/api/prueba/todosLosValoresReclamo/${reclamo.id}`);
        setValores(resValores.data);
        setValoresAct(resValores.data);
        setCargando(true);
      } catch (error) {
        console.error('Error fetching data', error);
      }
    };
    fetchData();
  }, [reclamo]);
  const handleInputChange = (ev, fieldName) => {
    const { type, checked, value } = ev.target;
    setValoresAct(prevState => ({ ...prevState, [fieldName]: type === 'checkbox' ? checked : value }));
  };
  const obtenerFechaHoy = () => {
    const hoy = new Date();
    const dia = String(hoy.getDate()).padStart(2, '0');
    const mes = String(hoy.getMonth() + 1).padStart(2, '0');
    const año = hoy.getFullYear();
    const horas = String(hoy.getHours()).padStart(2, '0');
    const minutos = String(hoy.getMinutes()).padStart(2, '0');
    const segundos = String(hoy.getSeconds()).padStart(2, '0');
    return `${dia}/${mes}/${año} ${horas}:${minutos}:${segundos}`;
  };
  const act = async (e, estado) => {
    e.preventDefault();
    const camposRelacionados = camposEstado.filter(c => c.relacionadoConEstado === estado.id);
    const valoresAEnviar = {};
    if (camposRelacionados.length > 0) {
      const nombreCampoFecha = camposRelacionados[0].nombre;
      valoresAEnviar[nombreCampoFecha] = obtenerFechaHoy();
    }
    camposRelacionados.slice(1).forEach(campo => {
      if (valoresAct[campo.nombre] !== undefined) {
        valoresAEnviar[campo.nombre] = valoresAct[campo.nombre];
      }
    });
    await axios
      .post(`https://back.agsseguros.online/api/general/actualizarValoresEstado`, { id: reclamo.id, valores: valoresAEnviar })
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch(error => {
        console.error('Error al actualizar:', error);
      });
  };
  const idsBase = codigos?.flatMap(c => c.estados?.split(',').map(Number)) || [];
  const idsFiltrados = idsBase.filter(id => id !== 201 && id !== 203);
  const ids = [...idsFiltrados, 201, 203];
  const filtrados = estados?.filter(e => ids.includes(e.id)).sort((a, b) => ids.indexOf(a.id) - ids.indexOf(b.id));
  return (
    <div>
      {cargando ? (
        <div className='contenedorSlideEstadosDer'>
          {filtrados?.map((estado, index) => {
            const camposRelacionados = camposEstado.filter(c => c.relacionadoConEstado === estado.id && c.oculto === 0);
            return (
              <section
                className='burbujaModuloActualizacionStro1'
                style={{
                  height: 'auto',
                  padding: '20px',
                  marginBottom: '20px',
                  background: '#FFFFFF 0% 0% no-repeat padding-box',
                  border: '1px solid #8D8D8D',
                  borderRadius: '19px',
                }}
                key={index}>
                <div className='d-flex justify-content-between align-items-center mb-3'>
                  <h2 className=' tituloModuloEstados'>{estado.nombre}</h2>
                  <h2 className={valores[camposRelacionados[0]?.nombre] ? 'modificacionModuloEstados' : 'd-none'}>
                    <i class='bi bi-calendar-week me-1'></i> Ult Mod: {camposRelacionados.length > 0 ? valores[camposRelacionados[0].nombre] : null}
                  </h2>
                </div>
                <form onSubmit={e => act(e, estado)}>
                  <div className='containerEstados'>
                    {camposRelacionados.slice(1).map((campo, campoIndex) => (
                      <div className='grid-item' key={campoIndex}>
                        <label htmlFor='' className='labelEstados'>
                          {campo.label.toUpperCase()}
                        </label>
                        {campo.type === 'select' ? (
                          <select
                            disabled={cookies?.user?.titulo === 'lector'}
                            className='burbujaModuloActualizacionStro1Light'
                            value={valoresAct[campo.nombre] || ''}
                            onChange={ev => handleInputChange(ev, campo.nombre)}>
                            {(valoresAct[campo.nombre] === null || valoresAct[campo.nombre] === '') && (
                              <option value='' disabled>
                                Selecciona una opción
                              </option>
                            )}
                            {campo.opciones.split(',').map((opcion, opcionIndex) => (
                              <option key={opcionIndex} value={opcion.trim()}>
                                {opcion.trim()}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type={campo.type}
                            disabled={cookies?.user?.titulo === 'lector'}
                            className={campo.type === 'checkbox' ? 'form-check-input rounded-pill' : 'burbujaModuloActualizacionStro1Light'}
                            style={campo.type === 'date' ? { maxWidth: '140px' } : campo.type === 'number' ? { maxWidth: '140px' } : {}}
                            value={campo.type !== 'checkbox' ? valoresAct[campo.nombre] : undefined}
                            checked={campo.type === 'checkbox' ? valoresAct[campo.nombre] : undefined}
                            onChange={ev => handleInputChange(ev, campo.nombre)}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                  <div className='d-flex justify-content-end align-items-center mt-3 mb-4'>
                    <button type='submit' className='botonActualizarEstados' disabled={cookies?.user?.titulo === 'lector'}>
                      Actualizar
                    </button>
                  </div>
                </form>
              </section>
            );
          })}
        </div>
      ) : (
        <div className='SpinnerInTheMiddle center'>
          <div class='spinner-border text-success center' role='status'>
            <span class='visually-hidden center'>Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
}
